/* Avi The Gem Guy — accessibility corrections for third-party widgets.

   Judge.me wraps its star display in role="img" with an aria-label, then puts a real
   link inside it. An element with role="img" must not contain focusable children: a
   screen reader presents the whole thing as one image, so the link inside becomes
   unreachable, and axe reports it as nested-interactive.

   The link already carries its own visible text ("4.92 out of 5"), so removing the
   role and the label from the wrapper is enough - the stars themselves are empty
   spans drawn in CSS and carry nothing for assistive tech to lose.

   Written generically rather than against .jdgm-rev-widg__summary-stars, so it keeps
   working if Judge.me renames that class, and catches the same mistake elsewhere. */
(function () {
  var FOCUSABLE = 'a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])';

  function fix() {
    var imgs = document.querySelectorAll('[role="img"]');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].querySelector(FOCUSABLE)) {
        imgs[i].removeAttribute('role');
        imgs[i].removeAttribute('aria-label');
      }
    }
  }

  /* An element marked aria-hidden="true" is hidden from screen readers, but that alone does
     not take its contents out of the tab order. The FAQ accordion collapses panels to height 0
     while leaving them visibility: visible, so a keyboard user tabs into mailto: links sitting
     in panels they cannot see - three of them on /pages/faqs.

     inert is the matching behaviour for what aria-hidden already asserts, and it changes
     nothing visually. Skipped when the element holds focus, so this can never pull focus out
     from under someone mid-interaction. */
  /* Only content the user cannot see. An element that is on screen and marked aria-hidden while
     holding real controls is a different defect, and inert is the wrong answer to it: it disables
     the control for the mouse as well, which is how the carat slider on the loose gems collection
     came to look live and do nothing. Fix that case in the markup, not here. */
  function isHiddenFromSight(el) {
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return true;
    var cs = window.getComputedStyle(el);
    return cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0;
  }

  function syncInert() {
    var hidden = document.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < hidden.length; i++) {
      var el = hidden[i];
      if (el.hasAttribute('inert') || el.contains(document.activeElement)) continue;
      if (el.querySelector(FOCUSABLE) && isHiddenFromSight(el)) el.setAttribute('inert', '');
    }
    var inerts = document.querySelectorAll('[inert]');
    for (var j = 0; j < inerts.length; j++) {
      if (inerts[j].getAttribute('aria-hidden') !== 'true') inerts[j].removeAttribute('inert');
    }
  }

  function run() {
    fix();
    syncInert();
  }

  /* The Upcart drawer renders inside a shadow root, so no stylesheet in the theme reaches it -
     including the site's focus ring. Measured with the drawer open: the quantity input takes
     focus with outline NONE and no box-shadow, i.e. no visible focus indicator at all, which
     is a 2.4.7 failure at AA rather than a contrast quibble.

     The root is open, so a style element can be appended to it. This is additive and touches
     nothing of Upcart's own CSS; it only supplies the indicator they leave out, matching the
     ring used everywhere else on the site.

     Deliberately NOT adding role="dialog"/aria-modal here. The drawer has no focus trap - focus
     leaves it while the page behind is scroll-locked - and claiming modal semantics without
     trapping focus would tell a screen reader the rest of the page is inert when it is still
     reachable, which is worse than saying nothing. That one belongs with Upcart. */
  function upcartFocusRing() {
    var ID = 'avi-a11y-focus-ring';
    function inject() {
      var host = document.getElementById('upCart');
      if (!host || !host.shadowRoot) return false;
      if (host.shadowRoot.getElementById(ID)) return true;
      var s = document.createElement('style');
      s.id = ID;
      s.textContent =
        ':focus-visible{outline:2px solid #3f4428 !important;outline-offset:2px !important;' +
        'box-shadow:0 0 0 3px #f5f1e8 !important;}';
      host.shadowRoot.appendChild(s);
      return true;
    }
    if (inject()) return;
    /* The app mounts after us, and re-mounts its root on some updates. Watch for the host
       appearing rather than polling forever. */
    if (!window.MutationObserver) { setTimeout(inject, 2000); return; }
    var ob = new MutationObserver(function () { if (inject()) ob.disconnect(); });
    ob.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { ob.disconnect(); }, 20000);
  }

  /* mega-menu.js toggles .active on the hamburger when the drawer opens and closes but never
     tells assistive tech, so the button's state was unannounced. Mirror that one class. */
  function menuButtonState() {
    var btn = document.querySelector('button.m-hamburger-box');
    if (!btn) return;
    if (window.MutationObserver) {
      var sync = function () {
        btn.setAttribute('aria-expanded', btn.classList.contains('active') ? 'true' : 'false');
      };
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class'] });
      sync();
    }

    /* Two gaps in the open drawer, both measured at 390.

       It does not close on Escape. Clicking the hamburger is the theme's own toggle, so this
       closes it exactly as a pointer would and hands focus back to the control that opened it.

       And focus leaks: 26 tabs from the top put focus on a filter chip behind the drawer,
       which is covered by a backdrop and cannot be seen. The drawer fills the viewport, so it
       needs the same trap the search overlay got.

       Capture phase for both, so the theme's own handlers cannot pre-empt them. */
    var SEL = 'a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])';
    function menuOpen() { return btn.classList.contains('active'); }
    function searchIsOpen() {
      var sp = document.querySelector('.m-search-popup');
      return !!sp && sp.style.visibility !== 'hidden' && parseFloat(sp.style.opacity || '0') > 0.5;
    }

    document.addEventListener('keydown', function (e) {
      if (!menuOpen() || searchIsOpen()) return;
      var drawer = document.getElementById('m-menu-drawer');

      if (e.key === 'Escape' || e.key === 'Esc') {
        btn.click();
        e.preventDefault();
        setTimeout(function () {
          if (btn.offsetParent !== null || btn.getClientRects().length) btn.focus();
        }, 320);
        return;
      }

      if (e.key !== 'Tab' || !drawer) return;
      var f = [].filter.call(drawer.querySelectorAll(SEL), function (el) {
        return el.offsetParent !== null || el.getClientRects().length;
      });
      /* The hamburger is the drawer's close control once open, so it belongs inside the loop. */
      f.unshift(btn);
      if (f.length < 2) return;
      var first = f[0], last = f[f.length - 1], active = document.activeElement;
      if (!drawer.contains(active) && active !== btn) { first.focus(); e.preventDefault(); return; }
      if (e.shiftKey && active === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && active === last) { first.focus(); e.preventDefault(); }
    }, true);
  }

  function start() {
    run();
    searchOverlay();
    upcartFocusRing();
    menuButtonState();
    /* Panels flip aria-hidden as they open and close, so watch that attribute document-wide.
       Attribute-filtered observation is cheap; this is not a childList subtree watch. */
    if (window.MutationObserver) {
      var at;
      new MutationObserver(function () {
        clearTimeout(at);
        at = setTimeout(syncInert, 60);
      }).observe(document.documentElement, {
        attributes: true, subtree: true, attributeFilter: ['aria-hidden']
      });
    }
    /* The widget renders after us and re-renders on paging and sorting. Observe its own
       container where there is one; otherwise a couple of re-checks, rather than putting
       a subtree observer on the whole body for a widget that may not be on this page. */
    var host = document.querySelector('.jdgm-widget, #judgeme_product_reviews, .jdgm-rev-widg');
    if (host && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(run, 150);
      }).observe(host, { childList: true, subtree: true });
    } else {
      setTimeout(run, 1200);
      setTimeout(run, 3500);
    }
  }

  /* The search overlay behaves as a modal - position:fixed, a backdrop, body scroll locked -
     without keeping the contract one. Measured on /collections/fine-jewelry:
       - Escape did nothing, and the backdrop is pointer-events:none, so once it was open a
         keyboard user had no way to dismiss it at all.
       - Focus left the panel after its own 15 stops and carried on into the page behind, which
         is covered by a backdrop and cannot be seen.
       - No role="dialog" and no aria-modal, so a screen reader is never told it opened.

     Its close button turned out to be safe to drive: aria-label="Close", and although it is
     type="submit" it sits outside any form, so clicking it only closes - checked, the URL does
     not change. So Escape routes to the theme's own close rather than us hiding the panel
     behind its back and desyncing its state. */
  function searchOverlay() {
    var panel = document.querySelector('.m-search-popup');
    if (!panel) return;
    var SEL = 'a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])';
    var lastTrigger = null;

    /* Read the inline style the theme sets, not the computed value. The panel fades over
       0.25s, so at the moment the style mutation fires the computed opacity is still 0 and a
       computed check reports "closed" for the whole transition - and since no further mutation
       follows, it would never correct itself. The inline style states the intent at once. */
    function isOpen() {
      if (panel.style.visibility === 'hidden') return false;
      if (panel.style.opacity !== '') return parseFloat(panel.style.opacity) > 0.5;
      var cs = getComputedStyle(panel);
      return cs.visibility !== 'hidden' && parseFloat(cs.opacity || '0') > 0.5;
    }
    function closeButton() {
      var bs = panel.querySelectorAll('button');
      for (var i = 0; i < bs.length; i++) {
        if (bs[i].getAttribute('aria-label') === 'Close') return bs[i];
      }
      return null;
    }
    function reachable() {
      return [].filter.call(panel.querySelectorAll(SEL), function (el) {
        return el.offsetParent !== null || el.getClientRects().length;
      });
    }

    /* Remember what opened it so focus can go back there, per 2.4.3. */
    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      var t = el.closest('.m-header__search, [data-open-search], [data-search-popup]');
      if (t) lastTrigger = el.closest('button, a') || t;
    }, true);

    function sync() {
      if (isOpen()) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    }
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    sync();

    /* Capture phase. The theme has its own Escape handler that closes the panel and stops the
       event, so a bubble-phase listener here never ran on a real keypress - the panel closed
       and focus was left on <body>. It only showed up under a synthetic KeyboardEvent, which
       the theme ignores as untrusted, which is exactly the trap: the bug was invisible to the
       cheaper test. Capturing means we run first either way. Closing twice is harmless; the
       close button only sets opacity to 0. */
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        var b = closeButton();
        if (!b) return;
        b.click();
        e.preventDefault();
        /* Hand focus back, per 2.4.3. Two things make this less obvious than it looks: the
           theme hides the search button while the panel is open, so focusing it immediately is
           a no-op and focus falls to <body>; and remembering the trigger from a click listener
           proved unreliable, so the button is queried directly instead. Deferred past the 0.25s
           close so the control is back in the layout when focus lands on it. */
        setTimeout(function () {
          function usable(el) {
            return el && el.focus && (el.offsetParent !== null || el.getClientRects().length);
          }
          var back = usable(lastTrigger) ? lastTrigger : null;
          if (!back) back = document.querySelector('.m-header__search button');
          /* Below 768 the desktop search button is display:none and the search form sits inline
             in the header instead, so there is no trigger to go back to. Falling back to the
             first visible header control keeps focus where the user was rather than dropping it
             on <body>, which would restart tabbing from the top of the document. */
          if (!usable(back)) {
            var header = document.querySelector('.m-header, header');
            if (header) {
              var c = header.querySelectorAll('a[href],button,input,select,[tabindex]:not([tabindex="-1"])');
              for (var i = 0; i < c.length; i++) { if (usable(c[i])) { back = c[i]; break; } }
            }
          }
          if (!usable(back)) return;
          back.focus();
          /* Something in the theme's own close path puts focus back on <body> after ours lands
             at some breakpoints, so re-assert once. Cheap, and idempotent if nothing stole it. */
          setTimeout(function () {
            if (document.activeElement === document.body && usable(back)) back.focus();
          }, 280);
        }, 320);
        return;
      }

      if (e.key !== 'Tab') return;
      var f = reachable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { first.focus(); e.preventDefault(); return; }
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
